import { useForm } from "react-hook-form";
import axios from "axios";
import ObtieneDatosCookies from "../tools/obtieneDatosCookiesUsuario.js";
import { useState, useEffect } from "react";
import Swal from "sweetalert2";

function FormEditaMateria(props) {
  const Cursos = props.Cursos?.Cursos || [];
  const parametros = props.Datos;
  const usuario = ObtieneDatosCookies();

  const escuelaInicial =
    typeof parametros === "string"
      ? parametros
      : parametros?.escuela || "";

  const primerCurso = Cursos.find((x) => x != null);

  const [incumbencias, setIncumbencias] = useState([]);
  const [materiasExistentes, setMateriasExistentes] = useState([]);

  const [cursoData, setCursoData] = useState({
    id: primerCurso?.id || null,
    nombreCurso: primerCurso?.nombreCurso || "",
    fechaInicio: primerCurso?.fechaInicio || "",
    fechaFinalizacion: primerCurso?.fechaFinalizacion || "",
    cantDivisiones: primerCurso?.cantDivisiones || 1,
    sedeCursada: primerCurso?.sede || "",
  });

  const {
    register,
    formState: { errors },
    watch,
    handleSubmit,
    setValue,
  } = useForm({
    defaultValues: {
      escuela: escuelaInicial,
      cursoID: primerCurso?.id || "",
      curso: primerCurso?.nombreCurso || "",
      estadoMateria: "Activo",
      duracionIgualCurso: "Si",
    },
  });

  const cursoIDSeleccionado = watch("cursoID", primerCurso?.id || "");
  const duracionIgualCurso = watch("duracionIgualCurso", "Si");

  useEffect(() => {
    const cursito = Cursos.find(
      (c) => String(c.id) === String(cursoIDSeleccionado)
    );

    if (cursito) {
      setCursoData({
        id: cursito.id,
        nombreCurso: cursito.nombreCurso,
        fechaInicio: cursito.fechaInicio,
        fechaFinalizacion: cursito.fechaFinalizacion,
        cantDivisiones: cursito.cantDivisiones,
        sedeCursada: cursito.sede,
      });

      setValue("curso", cursito.nombreCurso);
    }
  }, [cursoIDSeleccionado, Cursos, setValue]);

  useEffect(() => {
    const escuela = escuelaInicial?.trim();

    if (!escuela || escuela.length < 4) {
      setIncumbencias([]);
      return;
    }

    const controller = new AbortController();

    const fetchIncumbencias = async () => {
      try {
        const response = await axios.post(
          `https://wwwa.isepsantafe.net.ar/expedientes/docentes/getIncumbenciasPorReferencia/${encodeURIComponent(
            escuela
          )}`,
          {},
          { signal: controller.signal }
        );

        const data = (response.data.incumbencias || []).sort((a, b) => {
          if (a.categoria?.descripcion && b.categoria?.descripcion) {
            if (a.categoria.descripcion < b.categoria.descripcion) return -1;
            if (a.categoria.descripcion > b.categoria.descripcion) return 1;
          }

          return a.nombreMateria.localeCompare(b.nombreMateria);
        });

        setIncumbencias(data);
      } catch (error) {
        if (!axios.isCancel(error)) {
          console.error("Error al obtener incumbencias:", error);
        }

        setIncumbencias([]);
      }
    };

    fetchIncumbencias();

    return () => controller.abort();
  }, [escuelaInicial]);

  useEffect(() => {
    if (!cursoData?.id) return;

    const controller = new AbortController();

    const fetchMateriasCurso = async () => {
      try {
        const response = await axios.post(
          "https://wwwa.isepsantafe.net.ar/expedientes/materias/devuelveMateriasPorCursoDocentes",
          {
            cursoID: cursoData.id,
            curso: cursoData.nombreCurso,
          },
          { signal: controller.signal }
        );

        setMateriasExistentes(response.data.materias || []);
      } catch (error) {
        if (!axios.isCancel(error)) {
          console.error("Error al obtener materias del curso:", error);
        }

        setMateriasExistentes([]);
      }
    };

    fetchMateriasCurso();

    return () => controller.abort();
  }, [cursoData?.id]);

  const guardarMateria = async (data) => {
    data.usuarioID = usuario.id;
    data.sedeID = usuario.sedeID;
    data.dependenciaID = usuario.destino;

    try {
      await axios.post(
        "https://wwwa.isepsantafe.net.ar/expedientes/materias/creaMateria/",
        data
      );

      Swal.fire({
        icon: "success",
        title: "Correcto",
        text: "Materia guardada correctamente.",
        confirmButtonColor: "#3085d6",
      });
    } catch (error) {
      console.error(error);

      let mensaje = "No se pudo guardar la materia.";

      if (error.response?.data?.message) {
        mensaje = error.response.data.message;
      }

      if (error.response?.data?.error) {
        mensaje += `<br><br><b>Detalle:</b> ${error.response.data.error}`;
      }

      Swal.fire({
        icon: "error",
        title: "Error",
        html: mensaje,
        confirmButtonColor: "#d33",
      });
    }
  };

  const onSubmit = (data) => {
    const cursoElegido = Cursos.find(
      (c) => String(c.id) === String(data.cursoID)
    );

    if (!cursoElegido) {
      Swal.fire("Atención", "Debe seleccionar un curso válido.", "warning");
      return;
    }

    data.cursoID = cursoElegido.id;
    data.curso = cursoElegido.nombreCurso;
    data.cantDivisiones = cursoElegido.cantDivisiones;
    data.sedeCursada = cursoElegido.sede;
    data.escuela = escuelaInicial;

    if (duracionIgualCurso === "Si") {
      data.fechaInicio = cursoElegido.fechaInicio;
      data.fechaFinalizacion = cursoElegido.fechaFinalizacion;
    } else {
      data.fechaInicio = data.fechaInicioMateria;
      data.fechaFinalizacion = data.fechaFinMateria;
    }

    const mensajeHTML = `
      <strong>📚 Materia:</strong> ${data.nombreMateria}<br>
      <strong>📅 Curso:</strong> ${data.curso}<br>
      <strong>🆔 ID Curso:</strong> ${data.cursoID}<br>
      <strong>⏰ Horas:</strong> ${data.bloqueHorario}<br>
      <strong>🏫 Escuela:</strong> ${data.escuela}<br>
      <strong>📆 Inicio:</strong> ${data.fechaInicio}<br>
      <strong>📆 Fin:</strong> ${data.fechaFinalizacion}<br>
      <strong>🏞️ Sede Cursada:</strong> ${data.sedeCursada}<br>
      <strong>🟢 Estado:</strong> ${data.estadoMateria}
    `;

    Swal.fire({
      title: "¿Confirmar envío?",
      html: mensajeHTML,
      icon: "info",
      showCancelButton: true,
      confirmButtonText: "Sí, confirmar",
      cancelButtonText: "Cancelar",
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
    }).then((result) => {
      if (result.isConfirmed) {
        guardarMateria(data);
      }
    });
  };

  return (
    <div
      style={{
        maxWidth: "600px",
        margin: "0 auto",
        padding: "20px",
        backgroundColor: "#fefefe",
        borderRadius: "10px",
        boxShadow: "0 4px 15px rgba(0,0,0,0.1)",
      }}
    >
      <h2 style={{ textAlign: "center", marginBottom: "20px" }}>
        Editar / Crear Materia
      </h2>

      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="form-floating mb-3">
          <select
            className="form-select"
            {...register("nombreMateria", { required: true })}
          >
            <option value="">Seleccione una materia</option>

            {incumbencias.length === 0 && (
              <option value="">No hay incumbencias</option>
            )}

            {incumbencias.map((inc, i) => {
              const materiaExistente = materiasExistentes.find(
                (m) => m.nombreMateria === inc.nombreMateria
              );

              let yaExiste = false;

              if (
                inc.nombreMateria ===
                  "MATERIAS UNICAS (Cursos, Jornadas y Talleres)" ||
                inc.nombreMateria ===
                  "AUDIOPERCEPTIVA Y PRÁCTICA DE BANDA" ||
                inc.nombreMateria === "Módulo: Asistencia vial"
              ) {
                yaExiste = false;
              } else if (materiaExistente) {
                yaExiste = materiaExistente.estadoMateria === "Activo";
              }

              const textoEstado =
                materiaExistente && materiaExistente.estadoMateria !== "Activo"
                  ? " Fue creada antes pero está Inactiva"
                  : "";

              return (
                <option key={i} value={inc.nombreMateria} disabled={yaExiste}>
                  {inc.categoria?.descripcion === "OPERACIONAL"
                    ? `${inc.nombreMateria} (Operacional)${textoEstado}`
                    : `${inc.nombreMateria}${textoEstado}`}
                </option>
              );
            })}
          </select>

          <label>Nombre de la Materia</label>
          {errors.nombreMateria && (
            <span style={{ color: "red" }}>Campo requerido</span>
          )}
        </div>

<div className="form-floating mb-3">
  <input
    type="number"
    className="form-control"
    placeholder="Horas"
    min="0"
    step="1"
    {...register("bloqueHorario", {
      required: "Debe indicar la cantidad de horas",
      valueAsNumber: true,
      min: {
        value: 0,
        message: "Las horas no pueden ser negativas",
      },
    })}
  />

  <label>Horas</label>

  {errors.bloqueHorario && (
    <span style={{ color: "red" }}>
      {errors.bloqueHorario.message}
    </span>
  )}
</div>

        <div className="form-floating mb-3">
          <select
            className="form-select"
            {...register("cursoID", { required: true })}
          >
            <option value="">Seleccione un curso</option>

            {Cursos.map((curso) => (
              <option key={curso.id} value={curso.id}>
                {curso.nombreCurso}
              </option>
            ))}
          </select>

          <label>Curso</label>
          {errors.cursoID && (
            <span style={{ color: "red" }}>Campo requerido</span>
          )}
        </div>

        <input type="hidden" {...register("curso")} />

        <div className="form-floating mb-3">
          <select className="form-select" {...register("duracionIgualCurso")}>
            <option value="Si">Sí</option>
            <option value="No">No</option>
          </select>
          <label>¿Duración igual al curso?</label>
        </div>

        {duracionIgualCurso === "No" && (
          <>
            <div className="form-floating mb-3">
              <input
                type="date"
                className="form-control"
                min={cursoData.fechaInicio}
                max={cursoData.fechaFinalizacion}
                {...register("fechaInicioMateria", {
                  required: duracionIgualCurso === "No",
                })}
              />
              <label>Fecha de inicio de la materia</label>
              {errors.fechaInicioMateria && (
                <span style={{ color: "red" }}>Campo requerido</span>
              )}
            </div>

            <div className="form-floating mb-3">
              <input
                type="date"
                className="form-control"
                min={cursoData.fechaInicio}
                max={cursoData.fechaFinalizacion}
                {...register("fechaFinMateria", {
                  required: duracionIgualCurso === "No",
                })}
              />
              <label>Fecha de finalización de la materia</label>
              {errors.fechaFinMateria && (
                <span style={{ color: "red" }}>Campo requerido</span>
              )}
            </div>
          </>
        )}

        <div className="form-floating mb-3">
          <select
            className="form-select"
            {...register("estadoMateria", { required: true })}
          >
            <option value="Activo">Activo</option>
            <option value="Inactivo">Inactivo</option>
          </select>

          <label>Estado</label>
          {errors.estadoMateria && (
            <span style={{ color: "red" }}>Campo requerido</span>
          )}
        </div>

        <div className="form-floating mb-3">
          <input
            type="text"
            value={escuelaInicial}
            readOnly
            className="form-control"
            placeholder="Escuela"
            {...register("escuela", { required: true })}
          />
          <label>Escuela</label>
          {errors.escuela && (
            <span style={{ color: "red" }}>Campo requerido</span>
          )}
        </div>

        <div className="d-flex justify-content-center gap-2">
          <input
            type="submit"
            value="Crear Materia"
            className="btn btn-success"
          />
        </div>
      </form>
    </div>
  );
}

export default FormEditaMateria;